// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_100UY","icon":"index_icon_cF_YC"};